export default {
    deprecated: 'This work space contains macro-trends that are no longer part of the current Trendone trend universe.',
    trendsIndicatorLabel: 'Search agent trend indicator',
    tooltip: {
        contextMenu: 'Become a participant to gain full access',
        visibility: {
            private: 'private',
            public: 'public'
        }
    }
}
